exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col {\n  background-color: #0000ff;\n  color: white;\n  height: 100vh;\n}\n\n.content {\n  width: 50%;\n  margin: auto;\n}\n\nh1 {\n  margin-bottom: 2rem;\n}\n\nh2 {\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 767px) {\n  .content {\n    width: 85%;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/education/education.component.css
// module id = ../../../../../src/app/education/education.component.css
// module chunks = main